import { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.jsx'
import '../styles/auth.css'

export default function Login() {
  const { user } = useAuth()
  const location = useLocation()

  const error = useMemo(() => {
    const params = new URLSearchParams(location.search)
    const err = params.get('error')
    if (!err) return null
    if (err === 'cancelled') return 'Авторизация в Steam была отменена.'
    if (err === 'verification_failed') return 'Не удалось проверить цифровую подпись Steam. Попробуйте ещё раз.'
    if (err === 'steam_unavailable') return 'Сервера Steam сейчас недоступны. Попробуйте через пару минут.'
    return 'Произошла ошибка при входе через Steam.'
  }, [location.search])

  if (user) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="page container auth-page">
      <div className="auth-card card">
        <div className="auth-head">
          <span className="eyebrow">CaseMania</span>
          <h1>Вход через Steam</h1>
          <p className="muted">Вход и регистрация осуществляются только через официальный аккаунт Steam.</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <div className="steam-login-container">
          <a href="/api/auth/steam" className="btn-steam-big">
            <svg className="steam-icon-big" viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
              <path d="M11.979 0C5.678 0 .511 4.86.022 11.037l6.432 2.658c.545-.371 1.203-.59 1.912-.59.063 0 .125.004.188.006l2.861-4.142V8.91c0-2.495 2.028-4.524 4.524-4.524 2.494 0 4.524 2.031 4.524 4.527s-2.03 4.525-4.524 4.525h-.105l-4.076 2.911c0 .052.005.105.005.159 0 1.875-1.515 3.396-3.39 3.396-1.635 0-3.016-1.173-3.331-2.727L.436 15.27C1.862 20.307 6.486 24 11.979 24c6.627 0 12-5.373 12-12S18.605 0 11.979 0z" />
            </svg>
            <span>Войти через Steam</span>
          </a>

          <p className="steam-disclaimer">
            Вход через OpenID безопасен: мы получаем только ваш публичный SteamID и аватар. Доступа к паролю или управлению вещами сайт не имеет.
          </p>

          <div className="auth-demo">
            <span className="tiny muted">Тестовый вход для разработчика:</span>
            <a href="/api/auth/steam/demo" className="linklike tiny">
              Войти через тестовый аккаунт Steam
            </a>
          </div>
        </div>
      </div>

      <aside className="auth-aside">
        <h3>Почему нам можно верить</h3>
        <ul className="auth-points">
          <li>
            <strong>Моментальный дроп.</strong> Полученные скины сразу падают в инвентарь
            с возможностью моментального вывода или продажи.
          </li>
          <li>
            <strong>Открытая математика.</strong> Отдача 92% одинакова во всех режимах,
            шансы каждого предмета видны прямо на странице кейса.
          </li>
          <li>
            <strong>Копейки, а не дроби.</strong> Баланс хранится целым числом — на
            округлениях никто не зарабатывает.
          </li>
        </ul>
      </aside>
    </div>
  )
}
